import Vue from 'vue';
import Vuex from 'vuex';
import user from './user';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		appid: '',
		redirectURL: '',
		certificate: ''
	},
	modules: {
		user,
	},
	actions,
	mutations,
	getters,
	strict: false
})
